import {Directive, Input} from '@angular/core';
import {AllowedValueRule} from '../../rules/rules';
import {BaseValidatorDirective} from './base-validator.directive';
import {NG_VALIDATORS} from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[ngModel][allowedValue]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: AllowedValueValidatorDirective,
            multi: true,
        }
    ],
})
export class AllowedValueValidatorDirective extends BaseValidatorDirective<AllowedValueRule> {
    @Input()
    public set allowedValue($value: any[]) {
        this.rule = $value && new AllowedValueRule($value);
    }
}
